export default "__VITE_ASSET__BhjpCCeQ__"